export function capitalizeFirstLetter(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Escapes a value for safe interpolation into an HTML string (text or quoted
// attribute context). Used where we build markup for `innerHTML`/mapbox
// `setHTML` from third-party feature data instead of React-rendered nodes.
export function escapeHtml(value: unknown): string {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

// Returns the value only if it is an http(s) URL, otherwise ''. HTML-escaping
// an attribute does not neutralize a `javascript:` URL, so href values built
// from third-party feature data must be protocol-checked before escaping.
export function safeUrl(value: unknown): string {
  const url = String(value);
  return /^https?:\/\//i.test(url) ? url : '';
}
